// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"659bcea9","805":"945525ec"}[chunkId] + ".chunk.js";
};